export var offsetParent = function (element) {
    var offsetParent = element.offsetParent;
    while (offsetParent && offsetParent.style.position === 'static') {
        offsetParent = offsetParent.offsetParent;
    }
    return offsetParent || element.ownerDocument.documentElement;
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/offset-parent.js
// module id = 115
// module chunks = 93